import type { Department } from '~/types/business';
import { pbRequest, pbRequestVoid } from '~/services/request';

// Company departments — the grouping axis for employees and report scoping.
export const departmentsService = {
    /**
     * Get departments for a company
     */
    async getDepartments(companyId: number): Promise<Department[]> {
        return await pbRequest<Department[]>(`/companies/${companyId}/departments`, {
            failure: 'Failed to fetch departments',
        });
    },

    /**
     * Save department (create or update)
     */
    async saveDepartment(companyId: number, deptData: { id?: number; name: string; color?: string }): Promise<any> {
        const method = deptData.id ? 'PATCH' : 'POST';
        const url = deptData.id
            ? `/companies/${companyId}/departments/${deptData.id}`
            : `/companies/${companyId}/departments`;

        return await pbRequest<any>(url, {
            method,
            body: deptData,
            expect: [200, 201],
            failure: 'Failed to save department',
        });
    },

    /**
     * Delete department
     */
    async deleteDepartment(companyId: number, deptId: number): Promise<void> {
        await pbRequestVoid(`/companies/${companyId}/departments/${deptId}`, {
            method: 'DELETE',
            expect: [200, 204],
            failure: 'Failed to delete department',
        });
    },
};
